import { ApiFabricator } from '@app/tests/utils/fabricators/ApiFabricator'

import type { ApiConsentType } from '@app/packages/api/v2/types/entities'

export class ApiConsentTypeFabricator extends ApiFabricator<ApiConsentType> {
  /** `id` is the key, as the server sends it. */
  protected getBase = (): ApiConsentType => ({
    type: 'consent_types',
    id: 'data_processing',
    attributes: {
      key: 'data_processing',
      name: 'Обработка персональных данных',
      description: 'Согласие на обработку персональных данных',
      required: true,
    },
  })
}
